import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetTagsForContactPickerQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type GetTagsForContactPickerQuery = { __typename?: 'Query'; getTagsByEvent: Array<{ __typename?: 'TagDefinition'; id: string; label: string }> };

export type GetGuestMembersForContactPickerQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  after?: Types.InputMaybe<Types.Scalars['GuestListMemberCursor']>;
}>;

export type GetGuestMembersForContactPickerQuery = {
  __typename?: 'Query';
  getGuestListMembersByEventId: {
    __typename?: 'GuestListMemberConnection';
    totalCount: number;
    pageInfo: { __typename?: 'GuestListMemberPageInfo'; hasNextPage: boolean; endCursor?: any | null };
    edges: Array<{
      __typename?: 'GuestListMemberEdge';
      node: {
        __typename?: 'GuestListMember';
        id: string;
        contact: {
          __typename?: 'Contact';
          id: string;
          firstName: string;
          lastName: string;
          email?: string | null;
          householdId: string;
          phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber'; id: string; number: string } | null> | null;
          household?: { __typename?: 'ContactHousehold'; id: string } | null;
        };
        guestKeys: Array<{ __typename?: 'GuestListMemberKey'; guestKey: string; disabledAt?: any | null }>;
        groups: Array<{ __typename?: 'GuestListMemberGroup'; groupId: string; groupLeader: boolean }>;
        tags: Array<{ __typename?: 'GuestListMemberTag'; tagDefinitionId: string; tagLabel?: string | null }>;
      };
    }>;
  };
};

export const GetTagsForContactPickerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTagsForContactPicker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTagsByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTagsForContactPickerQuery__
 *
 * To run a query within a React component, call `useGetTagsForContactPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsForContactPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsForContactPickerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetTagsForContactPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsForContactPickerQuery, GetTagsForContactPickerQueryVariables>) {
  return ApolloReactHooks.useQuery<GetTagsForContactPickerQuery, GetTagsForContactPickerQueryVariables>(GetTagsForContactPickerDocument, baseOptions);
}
export function useGetTagsForContactPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsForContactPickerQuery, GetTagsForContactPickerQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetTagsForContactPickerQuery, GetTagsForContactPickerQueryVariables>(GetTagsForContactPickerDocument, baseOptions);
}
export type GetTagsForContactPickerQueryHookResult = ReturnType<typeof useGetTagsForContactPickerQuery>;
export type GetTagsForContactPickerLazyQueryHookResult = ReturnType<typeof useGetTagsForContactPickerLazyQuery>;
export type GetTagsForContactPickerQueryResult = Apollo.QueryResult<GetTagsForContactPickerQuery, GetTagsForContactPickerQueryVariables>;
export const GetGuestMembersForContactPickerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGuestMembersForContactPicker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestListMemberCursor' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGuestListMembersByEventId' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'after' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contact' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phoneNumber' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'household' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'guestKeys' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'groupLeader' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'tagDefinitionId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tagLabel' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGuestMembersForContactPickerQuery__
 *
 * To run a query within a React component, call `useGetGuestMembersForContactPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestMembersForContactPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestMembersForContactPickerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetGuestMembersForContactPickerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestMembersForContactPickerQuery, GetGuestMembersForContactPickerQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetGuestMembersForContactPickerQuery, GetGuestMembersForContactPickerQueryVariables>(GetGuestMembersForContactPickerDocument, baseOptions);
}
export function useGetGuestMembersForContactPickerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestMembersForContactPickerQuery, GetGuestMembersForContactPickerQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetGuestMembersForContactPickerQuery, GetGuestMembersForContactPickerQueryVariables>(GetGuestMembersForContactPickerDocument, baseOptions);
}
export type GetGuestMembersForContactPickerQueryHookResult = ReturnType<typeof useGetGuestMembersForContactPickerQuery>;
export type GetGuestMembersForContactPickerLazyQueryHookResult = ReturnType<typeof useGetGuestMembersForContactPickerLazyQuery>;
export type GetGuestMembersForContactPickerQueryResult = Apollo.QueryResult<GetGuestMembersForContactPickerQuery, GetGuestMembersForContactPickerQueryVariables>;
